/* ====================================
*            ANGULAR IMPORTS
======================================= */

import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/* ====================================
*            CUSTOM IMPORTS
======================================= */

import { SharedComponentsModule } from '@app/shared/components';
import { AuthenticationRoutingModule } from './core-authentication-routing.module';
import { SharedUiModule } from '@app/shared/ui';
import { AuthLayoutComponent } from './components/auth-layout/auth-layout.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { RequestPasswordResetComponent } from './components/request-password-reset/request-password-reset.component';

@NgModule({
  declarations: [
    AuthLayoutComponent,
    LoginPageComponent,
    PasswordResetComponent,
    RequestPasswordResetComponent,
  ],
  imports: [
    CommonModule,
    SharedUiModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AuthenticationRoutingModule,
    SharedComponentsModule,
  ],
  exports: [AuthLayoutComponent],
  providers: [],
})
export class CoreAuthenticationModule {}
